const API_BASE_URL = (
  import.meta.env.VITE_AXON_API_BASE_URL
  || (import.meta.env.DEV ? "http://127.0.0.1:8000" : "https://api.axonleads.ru")
).replace(/\/$/, "");

export class AssistantApiError extends Error {
  constructor(message, details = {}) {
    super(message);
    this.name = "AssistantApiError";
    Object.assign(this, details);
  }
}

async function assistantRequest(idToken, path, options = {}) {
  let response;
  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      method: options.method || "GET",
      headers: {
        Authorization: `Bearer ${idToken}`,
        ...(options.body ? { "Content-Type": "application/json" } : {}),
        ...(options.idempotencyKey ? { "Idempotency-Key": options.idempotencyKey } : {}),
      },
      body: options.body ? JSON.stringify(options.body) : undefined,
      cache: "no-store",
      credentials: "omit",
      redirect: "error",
      referrerPolicy: "no-referrer",
    });
  } catch {
    throw new AssistantApiError("Нет связи с командным столом. Проверьте интернет.");
  }
  const payload = response.status === 204 ? null : await response.json().catch(() => null);
  if (!response.ok) {
    const error = payload?.error || {};
    throw new AssistantApiError(
      typeof error.message === "string" ? error.message : "Запрос не выполнен.",
      {
        status: response.status,
        code: error.code,
        preview: error.details?.preview || null,
        requestId: error.requestId,
      },
    );
  }
  return payload;
}

export function fetchAssistantToday(idToken, { includeTodayQueue = true } = {}) {
  const params = new URLSearchParams({ include_today_queue: String(includeTodayQueue) });
  return assistantRequest(idToken, `/v1/assistant/threads/today?${params.toString()}`);
}

export function sendAssistantTurn(idToken, input, idempotencyKey) {
  return assistantRequest(idToken, "/v1/assistant/turns", {
    method: "POST",
    body: input,
    idempotencyKey,
  });
}

export function confirmAssistantAction(idToken, draftId, idempotencyKey) {
  return assistantRequest(idToken, `/v1/assistant/actions/${draftId}/confirm`, {
    method: "POST",
    idempotencyKey,
  });
}

export function reviseAssistantAction(idToken, draftId, changes, idempotencyKey) {
  return assistantRequest(idToken, `/v1/assistant/actions/${draftId}/revise`, {
    method: "POST",
    body: { changes },
    idempotencyKey,
  });
}

export function deleteAssistantHistory(idToken) {
  return assistantRequest(idToken, "/v1/assistant/history", { method: "DELETE" });
}
